import { useNavigate, useSearchParams } from 'react-router-dom';
import { SEARCH_MODAL_QUERY_PARAM_NAME } from 'utils/routes';

const EMPTY_SEARCH_QUERY = 'undefined';

export function useSearchModal() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const currentQuery = params.get(SEARCH_MODAL_QUERY_PARAM_NAME) || undefined;
  const searchGenerator = (query: string) => {
    params.set(SEARCH_MODAL_QUERY_PARAM_NAME, query);
    return params.toString();
  };
  const isOpen = params.has(SEARCH_MODAL_QUERY_PARAM_NAME);

  return {
    currentQuery:
      currentQuery !== EMPTY_SEARCH_QUERY ? currentQuery : undefined,
    isOpen,
    openSearch: (newQuery?: string) => {
      navigate({ search: searchGenerator(newQuery || EMPTY_SEARCH_QUERY) });
    },
    closeSearch: () => {
      const newParams = new URLSearchParams(window.location.search);
      newParams.delete(SEARCH_MODAL_QUERY_PARAM_NAME);
      navigate({ search: newParams.toString() }, { replace: true });
    },
  };
}
